import React from 'react';
import { useTranslation } from 'react-i18next';
import DocVideo from '../components/ui/DocVideo';
import DocMarkdown from './markdown/DocMarkdown';
import { docIcon } from './docIcons';
import { renderInline } from './markdown/renderInline';

// The one narrated clip (plan §3); every other docs video is a muted loop.
const NARRATED = new Set(['welcome']);

/** Centre column: crumb, title, summary, the page's video, body, related. */
export default function HelpArticle({ page, byId, ctx }) {
  const { t } = useTranslation();
  if (!page) return null;
  const related = (page.related || []).map((id) => byId.get(id)).filter(Boolean);

  return (
    <article className="help-article-inner" data-page-id={page.id}>
      <div className="help-crumb">{t('help.crumb', { section: page.section?.title || '' })}</div>
      <h1>{page.title}</h1>
      {page.summary && <p className="help-summary">{renderInline(page.summary, ctx, 'summary')}</p>}
      {page.video && (
        <div className="help-video">
          <DocVideo id={page.video} narrated={NARRATED.has(page.video)} label={page.title} />
        </div>
      )}
      <DocMarkdown page={page} ctx={ctx} />
      {related.length > 0 && (
        <section className="help-related">
          <h2>{t('help.related')}</h2>
          <div className="help-related-list">
            {related.map((p) => {
              const Icon = docIcon(p.icon);
              return (
                <button key={p.id} type="button" className="help-related-card" onClick={() => ctx.navigate(p.id)}>
                  <Icon size={16} aria-hidden="true" />
                  <span>
                    <b>{p.title}</b>
                    {p.summary && <small>{p.summary}</small>}
                  </span>
                </button>
              );
            })}
          </div>
        </section>
      )}
    </article>
  );
}
